@let isLoading = loadingCases();

<app-pan-card [isPageContainer]="true" [pageContainerSize]="'xl'" [header]="'Case Tracking'">
  <app-page-filters
    [allowBranchSelection]="true"
    branchSelectionLabel="Select Branches"
    [branchSelectionMulti]="true"
    [branchSelectionShowExternalId]="true"
    [branchRequestParams]="{ vertical: 'MicroMarket' }"
    [branchSelectionAutoSelectBranchIds]="defaultBranchIds()"
    [branchSelectionDisabled]="disableActions()"
    [(selectedBranches)]="selectedBranches"
    (selectedBranchesChange)="onBranchSelection()"
    [allowLocationSelection]="true"
    [allowLocationGroupSelection]="true"
    [locationGroupSelectionLabel]="'Select Location Groups'"
    [locationGroupSelectionMulti]="true"
    [locationGroupSelectionShowExternalId]="true"
    [locationGroupSelectionAutoSelectLocationIds]="defaultLocationGroupIds()"
    [locationGroupSelectionDisabled]="disableActions()"
    [(selectedLocationGroups)]="selectedLocationGroups"
    (selectedLocationGroupsChange)="onSelection()"
    [allowDateRangeSelection]="true"
    [dateRangeShowClear]="true"
    [(dateRangeStart)]="incidentDateFrom"
    [dateRangeStartDisabled]="disableActions()"
    dateRangeStartLabel="Incident Date From"
    (dateRangeStartChange)="refresh()"
    [(dateRangeEnd)]="incidentDateTo"
    [dateRangeEndDisabled]="disableActions()"
    dateRangeEndLabel="Incident Date To"
    (dateRangeEndChange)="refresh()"
  >
    <app-pan-form-control locationSelect>
      <app-pan-floating-label>Select Locations</app-pan-floating-label>
      <ng-select
        data-testid="page-select-location-control"
        appendTo="body"
        placeholder="Select locations..."
        [bindValue]="'id'"
        [bindLabel]="'name'"
        [virtualScroll]="true"
        [items]="sortedLocations()"
        [groupBy]="locationGroupBy"
        [multiple]="true"
        [disabled]="disableActions()"
        [(ngModel)]="selectedLocationIds"
        (change)="onSelection()"
        [loading]="loadingLocations()"
        loadingText="Loading locations..."
        [searchFn]="customSearchFn"
      >
        <ng-template ng-label-tmp let-item="item" let-clear="clear">
          <div class="flex items-center">
            <span class="ng-value-icon right" (click)="clear(item)" aria-hidden="true">×</span>
            <span>
              {{ item.name }}
              @if (item.external_id) {
                ({{ item.external_id }})
              }
            </span>

            @if (item.has_recent_incidents) {
              <app-pan-theft-status class="flex items-center px-2" [status]="'has-theft'"> </app-pan-theft-status>
            }
          </div>
        </ng-template>
        <ng-template ng-option-tmp let-item="item">
          <div class="flex justify-between items-center">
            <div>
              <p data-testid="location-option-name">
                {{ item.name }}
                @if (item.external_id) {
                  ({{ item.external_id }})
                }
              </p>
              <p class="text-sm italic">{{ item.branch_name }}</p>
            </div>

            @if (item.has_recent_incidents) {
              <app-pan-theft-status [status]="'has-theft'"></app-pan-theft-status>
            }
          </div>
        </ng-template>
      </ng-select>
    </app-pan-form-control>

    <div body>
      <div class="grid md:grid-cols-8 sm:grid-cols-1 gap-2">
        <app-pan-form-control class="col-span-1">
          <app-pan-floating-label>Min. Incidents </app-pan-floating-label>

          <input
            panInput
            panNumericInput
            [(ngModel)]="minIncidents"
            (ngModelChange)="ensureMinIncidents()"
            type="number"
            placeholder="# Incidents"
            min="0"
          />
        </app-pan-form-control>
      </div>

      <hr class="my-2" />

      <div class="my-2 flex gap-2">
        <app-pan-button icon="refresh" (click)="refresh()" [disabled]="disableActions()">Refresh Cases</app-pan-button>

        @if (cases().length > 0) {
          <div class="mx-2 border-l-2"></div>
          <app-pan-button (click)="expandAll()" [disabled]="disableActions()">Expand All</app-pan-button>
          <app-pan-button (click)="collapseAll()" [disabled]="disableActions()">Collapse All</app-pan-button>
        }

        @if (canSelectCases()) {
          <div class="mx-2 border-l-2"></div>

          <app-pan-button data-testid="select-new-cases-button" (click)="selectNewCases()" color="info" [disabled]="disableActions()"
            >Select New</app-pan-button
          >

          <div class="mx-2 border-l-2"></div>

          @if (showMergeCases()) {
            <swal
              #mergeSwal
              title="Merge Cases?"
              text="Are you sure you want to merge the {{ selectedCases().length }} selected cases?"
              icon="warning"
              confirmButtonText="Yes, Merge"
              [showCancelButton]="true"
              [focusCancel]="true"
              (confirm)="merge()"
            >
            </swal>

            <app-pan-button
              color="warning"
              [swal]="mergeSwal"
              [disabled]="disableActions() || !canMergeCases() || isMerging()"
              icon="merge"
              [state]="isMerging() ? 'loading' : 'default'"
            >
              Merge Cases
            </app-pan-button>
          }
        }

        @if (showShareCase()) {
          <app-share-email-modal
            modalTitle="Share Link to Case Report"
            [disabled]="disableShareCases()"
            [locationIds]="selectedLocationIds()"
            [isSharing]="isSharing()"
            (share)="share($event)"
            searchType="locations"
          ></app-share-email-modal>
        }

        @if (selectedCases().length > 0) {
          @if (canResolveSelectedCases() || canUnresolveSelectedCases()) {
            <div class="mx-2 border-l-2"></div>
          }

          @if (canResolveSelectedCases() && !canUnresolveSelectedCases()) {
            <app-pan-button
              color="info"
              (click)="resolveSelected()"
              [disabled]="disableActions() || isResolvingSelected()"
              [state]="isResolvingSelected() ? 'loading' : 'default'"
            >
              Resolve Selected
            </app-pan-button>
          }

          @if (canUnresolveSelectedCases()) {
            <app-pan-button
              color="warning"
              (click)="unresolveSelected()"
              [disabled]="disableActions() || isResolvingSelected()"
              [state]="isResolvingSelected() ? 'loading' : 'default'"
            >
              Unresolve Selected
            </app-pan-button>
          }
        }

        <div class="mx-2 border-l-2"></div>

        <app-pan-button
          data-testid="create-report-button"
          color="primary"
          [swal]="createReportSwal"
          [disabled]="disableActions() || selectedCases().length === 0"
        >
          Create Report
        </app-pan-button>
      </div>

      <hr class="mb-2" />
    </div>
  </app-page-filters>

  @if (!isLoading && selectedLocationIds().length === 0 && selectedBranches().length === 0 && selectedLocationGroups().length === 0) {
    <app-pan-blank-slate>
      <span>Select branches, locations or groups to view cases for</span>
    </app-pan-blank-slate>
  }

  @if (isLoading) {
    <app-pan-blank-slate>
      <app-pan-spinner></app-pan-spinner>
      <span>Loading cases...</span>
    </app-pan-blank-slate>
  }

  @if (error()) {
    <app-pan-inline-alert type="danger" class="mb-2 cursor-pointer" (click)="error.set(undefined)">
      {{ error() }}
    </app-pan-inline-alert>
  }

  @if (!isLoading && (selectedBranches().length > 0 || selectedLocationIds().length > 0 || selectedLocationGroups().length > 0)) {
    @if (cases().length > 0) {
      <div class="w-full mb-4 flex gap-2">
        <app-pan-stat-card class="flex-1" [value]="numNewCases()" stat="New Case(s)" color="primary"> </app-pan-stat-card>
        <app-pan-stat-card class="flex-1" [value]="numViewedCases()" stat="Viewed Case(s)" color="info"> </app-pan-stat-card>
        <app-pan-stat-card class="flex-1" [value]="numClientCases()" stat="Client Viewed Case(s)" color="warning"> </app-pan-stat-card>
        <app-pan-stat-card class="flex-1" [value]="numResolvedCases()" stat="Resolved Case(s)" color="success"> </app-pan-stat-card>
      </div>

      <ag-grid-angular #caseGrid [rowData]="ungroupedCases()" [columnDefs]="columnDefs" [gridOptions]="tableDef"></ag-grid-angular>
    } @else {
      <app-pan-blank-slate>No cases found.</app-pan-blank-slate>
    }
  }
</app-pan-card>

<app-pan-modal #findingsModal [topLevel]="true" data-testid="findings-modal">
  <div header>Findings</div>
  <div body data-testid="findings-content">
    {{ findings() }}
  </div>

  <div footer class="flex gap-2">
    <app-pan-button panModalClose>Close</app-pan-button>
  </div>
</app-pan-modal>

<swal
  #createReportSwal
  title="Create Report"
  text="What would you like to name the report for the {{ incidentIdsForSelectedCases().length }} selected incidents?"
  icon="question"
  confirmButtonText="Create Report"
  [showCancelButton]="true"
  [focusCancel]="true"
  (confirm)="createReport($event)"
  input="text"
  [inputAttributes]="{ minlength: '2', maxlength: '25' }"
  [inputValidator]="reportNameValidate"
>
</swal>
